export default {
    modalQuickActionVariations: {
        title: 'AI',
        generateWithAi: 'Genereren met AI',
        improveWriting: 'Verbeter het schrijven',
        fixSpelling: 'Verbeter spelling en grammatica',
        simplifyWriting: 'Vereenvoudig het schrijven',
        makeLonger: 'Langer maken',
        makeShorter: 'Korter maken',
        replaceText: 'Vervang tekst',
        addBelow: 'Voeg hieronder toe',
        cancel: 'Annuleer',
        selectQuickActionTitle: 'Zeg AI wat het hierna moet doen...',
        regenerate: 'Herstellen',
    },
};
